
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h16v16H0z"}}),_c('path',{attrs:{"d":"M14.083 2.45H2.022a1.7 1.7 0 00-1.7 1.7v7.8a1.7 1.7 0 001.7 1.7h12.06a1.7 1.7 0 001.7-1.7v-7.8a1.7 1.7 0 00-1.7-1.7zm.606 1.7v2.738h-3.444V3.54h2.838a.606.606 0 01.606.607zM2.022 3.54h8.124v3.352H1.422V4.157a.606.606 0 01.6-.617zm-.6 8.416V7.99h5.61v4.572h-5.01a.606.606 0 01-.606-.607zm12.666.607H8.122V7.99h6.565v3.965a.606.606 0 01-.606.607z"}})])
          )
        }
      }
    